import './menu.components.scss';
import {config} from "../../../config.js";


export class MenuComponent {
    static burgerButton = document.getElementById('burger-button');
    static headerOverlay = document.getElementById('overlay-menu');
    static headerMenu = document.getElementById('header-menu');
    static headerElement = document.querySelector("[data-header-js]");
    static menuCasesLink = document.getElementById('menu-cases-link');

    static isMenuActive = false;

    static init() {
        this.menuCasesLink.href = config.blogUrl;
        document.addEventListener('click', this.onBurgerButtonClick.bind(this));
    }
    // Открытие/закрытие бургер меню
    static onBurgerButtonClick(eve) {
        const { target } = eve;
        this.isMenuActive = this.burgerButton?.classList.contains("is-active");
        const headerElementHeightPx = this.headerElement.getBoundingClientRect().height.toFixed(1) + "px"
        // Открытие меню
        if (!this.isMenuActive && target === this.burgerButton) {
            this.burgerButton.classList.add("is-active");
            this.headerOverlay.classList.add("is-active");
            this.headerMenu.classList.add("is-active");
            document.documentElement.classList.add("is-lock");
            this.headerElement.style.position = "fixed";

            // компенсируем высоту header когда он вырывается из dom
            document.body.style.paddingTop = headerElementHeightPx;

            return;
        }

        // Закрытие меню
        if (this.isMenuActive &&
            (target.hasAttribute("data-menu-link") || target === this.burgerButton) &&
            !target.hasAttribute('data-feedback-btn')) {
            this.closeBurgerMenu();
        }
    }

    // Закрытие меню
    static closeBurgerMenu() {
        this.burgerButton.classList.remove("is-active");
        this.headerOverlay.classList.remove("is-active");
        this.headerMenu.classList.remove("is-active");
        document.documentElement.classList.remove("is-lock");
        document.body.style.paddingTop = "";
        this.headerElement.style.position = "";
    }

}